<div class="modal fade show custom_popup" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">Reconcile Account</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="iframe-container ps-1 pe-1">
        <div class="row d-flex">
          <div class="left-grid">
            <div class="ag-theme-quartz">
              <h6 class="text-center mt-1">To select a payment receipt, double-click any row below</h6>
              <div [ngClass]="getDynamicClass(rowData_Left?.length || 0)">
                <app-grid-container
                  [gridRowData]="rowData_Left"
                  [gridColDefs]="colDefs_Left"
                  [gridDefaultColDef]="defaultColDef"
                  (gridReady)="onGridReady_Left($event)"
                  (rowDoubleClicked)="getTradeTransactionsData($event)"
                />
              </div>
              <h6 class="mt-3 ms-2 me-2 text-center">
                <b>Note: </b>any unused or remaining balance will be available
                <span class="custom-text-margin">for off-set against other ETR at any future date</span>
              </h6>
            </div>
          </div>

          <div class="right-grid">
            <div class="ag-theme-quartz">
              <h6 class="text-center mt-1">To allocate a payment select/multi-select the ETR below</h6>
              <div [ngClass]="getDynamicClass(rowData_Right?.length || 0)">
                <app-grid-container
                  [gridRowData]="rowData_Right"
                  [gridColDefs]="colDefs_Right"
                  [gridDefaultColDef]="defaultColDef"
                  (selectionChanged)="showTotalValue($event)"
                  (gridReady)="onGridReady_Right($event)"
                  (sortChanged)="onSortChanged_Right($event)"
                />
              </div>
            </div>

            <div class="footer-fields d-flex justify-content-between align-items-start">
              <div class="view-all-toggle">
                <div class="form-check form-switch d-flex p-0">
                  <label class="form-check-label" for="flexSwitchCheckDefault">Show All Credebtors</label>
                  <input
                    class="form-check-input ms-1"
                    [(ngModel)]="isShowAll"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    (change)="showAllCredebtors($event)"
                  />
                </div>

                <div class="form-check form-switch d-flex p-0 justify-content-end">
                  <label class="form-check-label" for="flexSwitchCheckDefault"
                    >Trailing Balance
                    <span class="tooltip-ng ms-0" placement="bottom" ngbTooltip="'Trailing Balance'">
                      <i class="bi bi-question-circle"></i>
                    </span>
                  </label>
                  <input
                    class="form-check-input ms-1"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    [(ngModel)]="isTrailingBalance"
                    (change)="onTrailingBalanceChange($event)"
                  />
                </div>
              </div>
              <div>
                <div class="this-value-2">
                  <div class="d-flex gap-1 justify-content-between">
                    <p>Total Value:</p>
                    <strong>{{ totalFaceValue ? totalFaceValue : '0' }}</strong>
                  </div>
                  <div class="width-170 form-group mt-1 d-flex gap-1">
                    <p class="text-nowrap me-1">
                      Deduction
                      <span class="tooltip-ng ms-0" placement="bottom" ngbTooltip="'Deduction'">
                        <i class="bi bi-question-circle"></i>
                      </span>
                    </p>

                    <input
                      type="text"
                      [appOnlyNumber]="true"
                      id="deduction"
                      [(ngModel)]="deduction"
                      (input)="onDeductionChange($event)"
                      class="form-control sd-width numberText"
                    />
                  </div>
                  <div class="this-value-2">
                    <div class="width-170 form-group mt-1 d-flex gap-1 justify-content-between">
                      <p class="m-0">This Value:</p>
                      <p class="m-0">
                        <b>{{
                          parseFloat(remainingValue) >= 0
                            ? remainingValue
                            : parseFloat(remainingValue) < 0
                              ? formatNegativeValue(remainingValue)
                              : 0.0
                        }}</b>
                      </p>
                    </div>
                    <div class="width-170 form-group d-flex gap-1">
                      <p class="m-0">must be 0.00 to process</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-1 mb-3">
            <div class="d-flex justify-content-center">
              <button
                [disabled]="isProcessButtonActive"
                type="submit"
                class="btn btn-light me-3 btn-custom-footer save_btn"
              >
                Process
              </button>
              <button
                type="button"
                class="btn btn-light btn-custom-footer cancel_btn"
                data-dismiss="modal"
                (click)="closeModal()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
